import styled from 'styled-components';

import { colors } from '@/globalStyles';

export const RowWrapper = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: 50px 1fr;
`;

export const Label = styled.p`
  padding: 0;
  margin: 0;
  font-family: Lato;
  font-size: 16px;
  color: ${props => (props.color ? props.color : colors.black)};
`;

export const TooltipBodyWrapper = styled.div`
  width: auto;
  margin-top: 0px;
  display: grid;
  align-items: center;
  grid-template-rows: repeat(2, 45px);
  padding: 20px;
`;

export const SubLabel = styled.p`
  padding: 0;
  margin: 0;
  font-family: Lato;
  font-size: 14px;
  color: ${props => (props.color ? props.color : colors.black)};
`;

export const TooltipLengthInput = styled.input`
  width: 68px;
  height: 36px;
  flex-grow: 0;
  margin: 0 0 0 15px;
  padding: 10px;
  border-radius: 2px;
  border: solid 1px #007e83;
  background-color: white;
  :focus {
    outline: none;
  }
`;

export const TooltipRowWrapper = styled.div`
  cursor: pointer;
  display: grid;
  align-items: center;
  grid-template-columns: 36px 1fr;
  grid-column-gap: 5px;
`;

export const TooltipRowWithInput = styled(RowWrapper)`
  cursor: pointer;
  display: grid;
  align-items: center;
  grid-template-columns: 36px 1fr 68px min-content 10px;
  grid-column-gap: 5px;
`;

export const Icon = styled.img`
  width: 30px;
  height: 30px;
`;
